import React from "react";
import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";

//import MUI
import { Modal } from "antd";

const SelectMaterial = (props) => {
  // redux

  const {
    openModal,
    setOpenModal,
    material,
    selectMaterial,
    setSelectedMaterial,
  } = props;

  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  return (
    <Modal
      title="انتخاب نوع تیشرت"
      centered
      open={openModal}
      onOk={() => setOpenModal(false)}
      onCancel={() => setOpenModal(false)}
      okText={"تایید"}
      cancelText="انصراف"
    
    >
      <div className="row justify-content-center">
        <hr className="p-0 mb-2" />
        {material.map((item, index) => (
          <div className="row mb-5 justify-content-center " key={index}>
            <div className="col-12 p-0  text-center">
              <Skeleton
                sx={{ borderRadius: "10px", marginTop: "15px" }}
                className={isImageLoaded ? "d-none" : "d-block"}
                animation="wave"
                variant="rounded"
                width={"100%"}
                height={455}
              />
              <img
                className={isImageLoaded ? "d-block" : "d-none"}
                width={"100%"}
                src={item.material.Image1.mediaUrl}
                alt="First slide"
                onLoad={() => setIsImageLoaded(true)}
              />
            </div>
            <div className="col-12 p-0  text-center">{item.material.title}</div>

            <div className="col-12 p-0 ">
              <Button
                onClick={() => {
                  selectMaterial(item.value);
                  setSelectedMaterial(item.material);
                  setOpenModal(false);
                }}
                variant="contained"
                fullWidth={true}
                color="success"
              >
                انتخاب
              </Button>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};
export default SelectMaterial;
